<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { formatSocialNumberWithDecimal } from '@/utils/formatter';
import { calculateVariation } from '@/utils/math';
import blipModel from '@/mixins/blip-model';

export default {
  name: 'BlipNonEngagedContacts',
  components: {
    SimpleDataWithVariation,
  },
  mixins: [
    blipModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    servicePath: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getBlipServiceWithVariation',
      'hasNoBlipBotAndContractFiltered',
      'getAppliedCardFilter',
    ]),
    async getData(options) {
      const appliedCardFilter = await this.getAppliedCardFilter(this.itemId);

      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      if (await this.hasNoBlipBotAndContractFiltered(this.itemId)) {
        this.requestStatus = 'emptyBot';
        return;
      }

      if (!this.isSingleBotSelected(appliedCardFilter)) {
        this.requestStatus = 'supportsOnlyOneBot';
        return;
      }

      this.getBlipServiceWithVariation({
        servicePath: this.servicePath,
        itemId: this.itemId,
      })
        .then((response) => {
          const previousData = this.returnBlipSingleBotResponse(response.previousData);
          const currentData = this.returnBlipSingleBotResponse(response.currentData);

          const previousValue = previousData.resource.nonEngagedContacts;
          const currentValue = currentData.resource.nonEngagedContacts;
          const variation = calculateVariation(previousValue, currentValue);

          this.value = formatSocialNumberWithDecimal(currentValue);
          this.variation = variation;
          this.rawVariation = variation;
          this.comparationValue = formatSocialNumberWithDecimal(previousValue);
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = error.message;
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
